import { useQuery } from "react-query";
import Axios from "axios";
import { GeneralPermissions } from "src/types";
import { baseDataKeys } from "src/query-keys";

export function usePermissions() {
  async function queryFn(): Promise<GeneralPermissions> {
    const response = await Axios.get("/planning-api/permissions");
    return response.data;
  }
  return useQuery(baseDataKeys.permissions, queryFn);
}
